var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"card-description"}},[(_vm.cardSettings.expandDescription)?_c('read-more',{attrs:{"more-str":"Read more","less-str":"Read less","text":_vm.text,"max-chars":150}}):_c('label',{staticClass:"card-content cursor-inherit",domProps:{"innerHTML":_vm._s(_vm.text)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }